import Alpine from 'alpinejs';

const canUseStorage = () => {
    try {
        const key = '__avari_storage_test__';
        window.localStorage.setItem(key, key);
        window.localStorage.removeItem(key);
        return true;
    } catch {
        return false;
    }
};

const storageAvailable = canUseStorage();

const isDismissed = (key) => {
    if (!storageAvailable) return false;
    return window.localStorage.getItem(key) === 'true';
};

const dismiss = (key) => {
    if (!storageAvailable) return;
    window.localStorage.setItem(key, 'true');
};

Alpine.data('promoBanner', ({ storageKey }) => ({
    storageKey,
    isVisible: false,
    resizeObserver: null,

    init() {
        if (typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(() => this.updateBannerHeight());
            this.resizeObserver.observe(this.$el);
        }

        this.$watch('$store.user.isFetched', () => this.syncVisibility());
        this.$watch('$store.user.isLoggedIn', () => this.syncVisibility());
        this.syncVisibility();
    },

    syncVisibility() {
        this.isVisible = this.$store.user.isFetched
            && !this.$store.user.isLoggedIn
            && !isDismissed(this.storageKey);

        document.documentElement.classList.toggle('has-promo-banner', this.isVisible);
        this.$nextTick(() => this.updateBannerHeight());
    },

    updateBannerHeight() {
        if (!this.isVisible) {
            document.documentElement.style.removeProperty('--promo-banner-height');
            return;
        }

        document.documentElement.style.setProperty(
            '--promo-banner-height',
            `${Math.ceil(this.$el.offsetHeight)}px`,
        );
    },

    dismiss() {
        dismiss(this.storageKey);
        this.isVisible = false;
        document.documentElement.classList.remove('has-promo-banner');
        document.documentElement.style.removeProperty('--promo-banner-height');
    },

    destroy() {
        this.resizeObserver?.disconnect();
    },
}));

Alpine.data('promoPopup', ({ delay = 5000, storageKey }) => ({
    delay,
    storageKey,
    timer: null,
    manuallyDismissed: false,

    init() {
        this.$watch('$store.user.isFetched', () => this.schedule());
        this.$watch('$store.user.isLoggedIn', () => this.schedule());
        this.schedule();
    },

    schedule() {
        window.clearTimeout(this.timer);

        if (
            this.manuallyDismissed
            || isDismissed(this.storageKey)
            || !this.$store.user.isFetched
            || this.$store.user.isLoggedIn
        ) {
            return;
        }

        this.timer = window.setTimeout(() => {
            if (!this.$refs.dialog?.open) {
                this.$refs.dialog?.showModal();
            }
        }, this.delay);
    },

    dismiss() {
        this.manuallyDismissed = true;
        dismiss(this.storageKey);
        window.clearTimeout(this.timer);
        this.$refs.dialog?.close();
    },

    handleClose() {
        window.clearTimeout(this.timer);
    },
}));
